import { Component, OnInit } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RatingsComponent } from '../ratings/ratings.component';
import { LanguageChooserComponent } from '../../../../shared/components/language-chooser/language-chooser.component';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-logo-app-links',
    templateUrl: './logo-app-links.component.html',
    styleUrls: ['../footer.component.scss'],
    standalone: true,
    imports: [FlexModule, NgClass, ExtendedModule, LanguageChooserComponent, RatingsComponent]
})
/** *Logo App Links Component Component */
export class LogoAppLinksComponent implements OnInit {
	constructor(private http: HttpClientModule) {}
	ngOnInit(): void {}
}
